import React from "react";

/**
 * EmptyState — explains what's missing and what to do about it, instead of
 * a bare "no items" line. Used for genuinely-empty queues AND for
 * not-yet-backed pages (pass `isComingSoon` for the latter).
 */
const EmptyState = ({ icon: Icon, title, description, action, isComingSoon = false }) => (
  <div className="p-10 text-center flex flex-col items-center gap-3">
    {Icon && (
      <span className="w-10 h-10 rounded-xl bg-surface/60 flex items-center justify-center text-celestial-muted">
        <Icon className="w-5 h-5" />
      </span>
    )}
    <div className="space-y-1">
      <div className="text-sm font-medium text-celestial-text">{title}</div>
      {description && <div className="text-xs text-celestial-muted max-w-sm mx-auto">{description}</div>}
    </div>
    {isComingSoon && (
      <span className="text-[10px] font-medium px-2 py-0.5 rounded-full border bg-surface/60 text-celestial-muted border-celestial-border/30 mt-1">
        Backend not wired up yet
      </span>
    )}
    {action}
  </div>
);

export default EmptyState;
